/* UX 15SEP2026 — Quick add por talla en tarjetas de producto.
   Usa el mismo mecanismo que product-form.js: /cart/add.js con "sections" para
   repintar el cart-drawer y abrirlo, sin recargar la página. */
(function () {
  const busy = new WeakSet();

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.size-button');
    if (!btn || btn.disabled || busy.has(btn)) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const cart = getCart();
    const wrapper = btn.closest('.size-quick-add');
    busy.add(btn);
    btn.classList.add('loading');
    wrapper && wrapper.classList.add('is-loading');

    const body = { id: variantId, quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || 'error');

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          // Fallback: actualizar contador y abrir drawer si existe
          fetch('/cart.js')
            .then((r) => r.json())
            .then((c) => {
              document.querySelectorAll('[data-cart-count], .cart-count, .cart__count').forEach((el) => {
                el.textContent = c.item_count;
              });
            });
          const drawer = document.querySelector('cart-drawer');
          drawer && typeof drawer.open === 'function' && drawer.open();
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'size-quick-add', productVariantId: variantId });
        }
        btn.classList.add('added');
        setTimeout(() => btn.classList.remove('added'), 1200);
      })
      .catch((err) => {
        console.error('Quick add:', err);
        btn.classList.add('error');
        setTimeout(() => btn.classList.remove('error'), 1500);
      })
      .finally(() => {
        busy.delete(btn);
        btn.classList.remove('loading');
        wrapper && wrapper.classList.remove('is-loading');
      });
  });
})();
